






































































































































































































































































































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  props: {
    egresoInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    proveedor: {},
    cuentasBancarias: [],
    banco: {},
    concepto: {},
    monto: '',
    descripcion: '',
    proveedores: [],
    menuDate: false,
    menuPeriod: false,
    rules: [(v) => v.length <= 50 || 'Max 50 characters'],
    date: '',
    period: '',
    openDialog: false,
    // openDialog1: false,
    headers: [
      { text: 'Cantidad', value: 'cantidad' },
      { text: 'Concepto', value: 'concepto.nombre' },
      { text: 'Descripción', value: 'descripcion' },
      { text: 'Monto Pago', value: 'monto' },
      // { text: 'Precio unitario', value: 'unitario' },
      // { text: 'Importe', value: 'importe' },
    ],
    items: [
    ],
    item: {
      key: '',
      concepto: {},
      descripcion: '',
      // unidadDeMedida: '',
      cantidad: 1,
      // unitario: 0,
      // impuesto: '',
      // impuestos: {
      //   baseImp: 0,
      //   importeImp: 0,
      //   imp: {},
      // },
      // importe: 0,
      monto: 0,
      // openTotal: 0,
      pagoStatus: 0,
    },
    Pago: {
      administracion: {},
      condominio: {},
      // unidad: {},
      // propietario: {},
      proveedor: {},
      monto: 0,
      items: [],
      // subtotal: 0,
      tipoDeComprobante: '',
      total: 0,
      fechaDeEmision: '',
      periodo: '',
      // folio: '',
      // serie: '',
      // totalImpuestos: 0,
      metodoDePago: '',
      referencia: '',
      prontoPagoEdit: false,
      fechaProntoPago: '',
    },
    loading: false,
    result: {},
    var: 0,
    unidades: [],
    conceptos: [],
    conceptosTemp: [],
    asociar: false,
    propietarios: [],
    total: 0,
    selected: [],
    isSelectedEmpty: true,
    precision: 2,
    formatoFecha: 'DD/MM/YYYY',
    formatPeriod: 'MM/YYYY',
    options: {},
    options1: {page: 1, itemsPerPage: 100000, sortBy: 0},
    unidadesPropietarios: [],
    unidadPropietario: {},
    // series: [],
    key: 0,
    selectedConcepto: {},
    // tipoDeComprobante: [{name: 'INGRESO'}, {name: 'EGRESO'}],
    tipoDeComprobante: [{name: 'EGRESO'}],
    idEgreso: 0,
    pagos: ['Efectivo', 'Cheque', 'Transferencia'],
  }),
  computed: {
    computedDateFormatted() {
      return this.$moment(this.date).format(this.formatoFecha);
    },
    computedPeriodFormatted() {
      return this.$moment(this.period).format(this.formatPeriod);
    },
    itemImporte() {
      if (!isNaN(this.item.cantidad * this.item.unitario)) {
        return (this.item.cantidad * this.item.unitario).toFixed(this.precision);
      } else {
        return (0).toFixed(this.precision);
      }
    },
  },
  methods: {
    restrictChars($event, e) {
      if (/[0-9]/.test(String.fromCharCode($event.charCode)) ||
          ($event.charCode === 46) && (e.indexOf('.') === -1) ) {
        return true;
      } else {
          $event.preventDefault();
      }
    },
    // addConcept() {
    //   console.log("paso X aqui");
    //   console.log("Pago: ", this.Pago);
    //   this.item
    //   this.items.push(this.item);
    // },
    async loadData() {
      this.loading = true;
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const datos = {admin, condo};
      // console.log('getUnidadesPropListMax datos: %o', datos);
      // const unidades = this.$store.dispatch('getUnidadesPropListMax', {datos})
      //   .then((response) => {
      //          // console.log('getUnidadesPropListMax response: %o', response);
      //          this.unidadesPropietarios = response.content;
      //          this.createUniPropLabels(this.unidadesPropietarios);
      //          console.log('unidadesPropietarios: ', this.unidadesPropietarios); })
      //   .catch((e) => {console.error(e);
      //                  this.$toast.error(e); });

      const proveedor = this.$store.dispatch('getProveedoresList2', {admin, condo})
        .then((result) => {console.debug('getProveedoresList2 response: %o', result);
                           this.proveedores = result; })
        .catch((e) => {console.error(e);
                       this.$toast.error(e); });

      const conceptos = this.$store.dispatch('getConceptoEgresosList', {admin, condo})
        .then((result) => {console.debug('getConceptoEgresosList response: %o', result.content);
                           this.conceptos = result.data; })
        .catch((e) => {console.error(e);
                       this.$toast.error(e); });
      const cuentaB = this.$store.dispatch('getCuentasList', {admin, condo, options: this.options1})
        .then((result) => {console.debug('getCuentaList response: %o', result);
                           this.cuentasBancarias = result; })
        .catch((e) => {console.error(e);
                       this.$toast.error(e); });
      // const series = this.$store.dispatch('getSeriesList', datos)
      //   .then((response) => {console.log('getSeriesList response: %o', response);
      //                        this.series = response; })
      //   .catch((e) => {console.error(e);
      //                  this.$toast.error(e); });
      // Promise.all([unidades, conceptos, series])
      Promise.all([proveedor, conceptos, cuentaB])
        .then((values) => this.loading = false);
    },
    close() {
      this.openDialog1 = false;
      setTimeout(() => {
        this.item = this.modeloitem();
        // this.item.importe = 0;
        // this.item.concepto = {};
        this.selectedConcepto = {};
      }, 300);
    },
    closePago() {
      this.openDialog = false;
      this.Pago = {
        subtotal: 0,
        totalImpuestos: 0,
        total: 0,
      };
      this.unidadPropietario = {};
      this.total = 0;
      this.items = Object.assign([]);
      this.key = 0;
      // this.date = this.$moment().format();
    },
    addConcept() {
      // console.log("paso X aqui");
      console.log('Pago: ', this.Pago);
      // this.item
      // this.items.push(this.item);

      // console.log('ConceptoDescripcion %o', this.item.concepto);
      // if (!this.isConceptoValid(this.selectedConcepto)) {
      //   this.$toast.error('Seleccione un concepto');
      //   return;
      // }
      this.key++;
      this.item.key = this.key;
      this.item.concepto = this.concepto;
      // this.item.cantidad = Number(this.item.cantidad);
      // this.item.unitario = Number(this.item.unitario);
      // this.item.importe = (this.item.cantidad * this.item.unitario).toFixed(this.precision);
      this.item.monto = this.monto;
      console.log('ADD-concepto', this.item.monto);
      this.item.descripcion = this.descripcion;
      // this.item.impuestos.baseImp = this.item.importe;
      // this.item.impuestos.importeImp = (this.item.importe * this.item.impuestos.imp.tasa)
      //   .toFixed(this.precision);
      // this.item.openTotal = Number(this.item.importe) + Number(this.item.impuestos.importeImp);
      this.item.pagoStatus = 0;
      this.items.push(this.item);
      console.log('items: ', this.items);
      // const totales = this.getTotals(this.items);
      // this.Pago.subtotal = totales.subtotal.toFixed(this.precision);
      // this.Pago.totalImpuestos = totales.totalImpuestos.toFixed(this.precision);
      // this.Pago.total = totales.total.toFixed(this.precision);
      // this.Pago.total = this.getTotals(this.items);
      this.Pago.monto = this.monto;
      this.close();
    },
    isConceptoValid(concepto) {
      if (Object.keys(concepto).length > 0) {
        return true;
      }
      return false;
    },
    getSubtotal(items) {
      let subtotal = 0;
      for (const item of items) {
        if (!item.concepto.adeudo) {
          subtotal += Number(item.impuestos.baseImp);
        }
      }
      return subtotal;
    },
    getTotalImpuestos(items) {
      let importeImp = 0;
      for (const item of items) {
        if (!item.concepto.adeudo) {
          importeImp += Number(item.impuestos.importeImp);
        }
      }
      return importeImp;
    },
    getTotals(items) {
      let total = 0;
      // const returnObject = {
        // subtotal: 0,
        // totalImpuestos: 0,
      //   total: 0,
      // };
      // const subtotal = this.getSubtotal(items);
      // const totalImpuestos = this.getTotalImpuestos(items);
      // const total = subtotal + totalImpuestos;
      // returnObject.subtotal = subtotal;
      // returnObject.totalImpuestos = totalImpuestos;
      // returnObject.total = total;
      for (const item of items) {
        total += Number(item.monto);
        // this.$store.getters.getCondo;
      }
      // });
      // return returnObject;
      return total;
    },
    async AgregarPago() {
      // if (this.unidadPropietario && this.Pago.serie && this.items.length > 0) {
      this.addConcept();
      if (this.items.length > 0) {
        try {
          this.loading = true;
          const admin = this.$store.getters.getAdmin;
          const condo = this.$store.getters.getCondo;
          const egreso = this.idEgreso;
          // const propietario = {id: this.unidadPropietario.propId};
          // const datos = {admin, condo, propietario};
          const datos = {admin, condo};
        //   // console.log('getPropietarioById datos: %o', datos);
        //   // const response = await this.$store.dispatch('getPropietarioById', datos);
        //   // console.log('getPropietarioById response: %o', response);
        //   // this.Pago.propietario = response.data;
        // } catch (e) {
        //   console.error(e);
        //   // this.$toast.error(e);
        //   this.$toast.error(e.response.data.message);
        // }
        // try {
        //   const admin = this.$store.getters.getAdmin;
        //   const condo = this.$store.getters.getCondo;
        //   const unidad = {id: this.unidadPropietario.unidadId};
        //   const datos = {admin, condo, unidad};this.$store.getters.getCondo;etUnidadById', datos);
        //   console.log('getUnidadById response: %o', response);
        //   this.Pago.unidad = response.data;
        // } catch (e) {
        //   console.error(e);
        //   // this.$toast.error(e);
        //   this.$toast.error(e.response.data.message);
        // }
        // try {
          this.Pago.creationDateTime = this.$moment().format();
          this.Pago.creationUsername = this.$store.getters.getUsername;
          this.Pago.pagoStatus = 'NOPAGADO';
          this.Pago.proveedor = this.proveedor;
          this.Pago.cuenta = this.banco;
          // this.Pago.administracion = this.$store.getters.getAdmin;
          // this.Pago.condominio = this.$store.getters.getCondo;
          this.Pago.administracion = admin;
          this.Pago.condominio = condo;
          this.Pago.items = this.items;
          // const totales = this.getTotals(this.items);
          // this.Pago.subtotal = totales.subtotal.toFixed(this.precision);
          // this.Pago.totalImpuestos = totales.totalImpuestos.toFixed(this.precision);
          // this.Pago.total = totales.total.toFixed(this.precision);
          this.Pago.fechaDeEmision = this.$moment(this.date).format();
          this.Pago.fechaProntoPago = this.$moment(this.date).format();
          this.Pago.periodo = this.$moment(this.period).format();
          if ( this.Pago.metodoDePago === this.pagos[1] ) {
            console.debug('MetodoDePago es CHEQUE');
            this.Pago.prontoPagoEdit = true;
          } else {
            console.debug('Metodo de pago no es CHEQUE');
            this.Pago.prontoPagoEdit = false;
          }
          console.log('addPago Pago: %o', this.Pago);
          const result = await this.$store.dispatch('addPago', {admin, condo, egreso, pago: this.Pago});
          console.log('addPago result: %o', result);
          this.$toast.success('Pago Agregado exitosamente');
        } catch (e) {
          console.error(e);
          // this.$toast.error(e);
          this.$toast.error(e.response.data.message);
        }
        this.loading = false;
        this.Pago = {
          administracion: {},
          condominio: {},
          proveedor: {},
          monto: 0,
          items: [],
          tipoDeComprobante: '',
          total: 0,
          fechaDeEmision: this.$moment(this.date).format(),
          periodo: '',
          metodoDePago: '',
          referencia: '',
        },
        this.monto = 0;
        this.banco = {};
        this.closePago();
        this.$emit('reload', {});
      } else {
        this.$toast.error('El pago requiere al menos un concepto');
      }
    },
    rowSelected(event) {
      const boolAndIndex = this.isConceptoInArray(event, this.selected);
      const isInSelected = boolAndIndex.boolValue;
      const index = boolAndIndex.index;
      if (isInSelected) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push(event);
      }
    },
    isConceptoInArray(concepto, conceptosArray) {
      const returnObject = {
        boolValue: false,
        index: 0,
      };
      let index = 0;
      for (const con of conceptosArray) {
        if (con.key === concepto.key) {
          returnObject.boolValue = true;
          returnObject.index = index;
          return returnObject;
        }
        index++;
      }
      returnObject.boolValue = false;
      returnObject.index = -1;
      return returnObject;
    },
    eliminarItems() {
      console.log('Key %o', this.selected);
      for (const item of this.selected) {
          const index = this.items.indexOf(item);
          this.items.splice(index, 1);
      }
      const totales = this.getTotals(this.items);
      this.Pago.subtotal = totales.subtotal;
      this.Pago.totalImpuestos = totales.totalImpuestos;
      this.Pago.total = totales.total;
      this.selected = [];
    },
    modeloitem() {
      return {
        key: '',
        concepto: {},
        descripcion: '',
        unidadDeMedida: '',
        cantidad: 0,
        unitario: 0,
        impuestos: {
          baseImp: 0,
          importeImp: 0,
          imp: {},
        },
        importe: 0,
      };
    },
    createUniPropLabels(uniPropArray) {
      for (const uniProp of uniPropArray) {
        const label = uniProp.nombreUnidad + ' / ' + uniProp.nombreInquilino;
        uniProp.label = label;
      }
    },
  },
  watch: {
    items() {
      this.total = this.items.length;
    },
    selected() {
      if (this.selected.length === 0) {
        this.isSelectedEmpty = true;
      } else {
        this.isSelectedEmpty = false;
      }
    },
    selectedConcepto(event) {
      if (Object.keys(event).length > 0) {
        this.item.concepto = event;
        this.item.impuestos.imp = event.impuesto;
        this.item.descripcion = event.descripcion;
        this.item.impuesto = event.impuesto.descripcion;
        this.item.unidadDeMedida = event.unidadMedida;
      }
    },
    openDialog() {
      console.log('AGREGAR-PAGOS: ', this.egresoInit);
      const prop = this.egresoInit[0];
      this.proveedor = prop.proveedor;
      this.concepto = prop.items.concepto;
      this.idEgreso = prop.id;

      this.loadData();
      this.date = this.$moment().format();
      this.period = this.date;
      console.log(this.date);
    },
  },
});
